export default class CountryCodes {
    static readonly switzerland = 'CH';
    static readonly liechtenstein = 'LI';
    static readonly germany = 'DE';
    static readonly austria = 'AT';
    static readonly italy = 'IT';
}